<template>
  <div
    id="dataScreen"
    class="app-container page-box"
    :class="{ 'is-full': isFullScreen }"
  >
    <span
      v-show="isFullScreen"
      class="iconfont icon-suoxiao btn"
      @click="toFullOrExit"
    ></span>
    <span
      v-show="!isFullScreen"
      class="iconfont icon-quanping btn"
      @click="toFullOrExit"
    ></span>
    <iframe
      id="iframe"
      :src="iframeSrc"
      height="100%"
      width="100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import {
  fullScreen,
  exitFullScreen,
  isFullScreen,
  fullToggle,
  addQueryToUrl
} from '@/utils/utils'
import { mapState } from 'vuex'

export default {
  name: 'DataScreen',

  data() {
    return {
      isFullScreen: false
    }
  },

  computed: {
    ...mapState('company', ['companyId']),

    iframeSrc() {
      return addQueryToUrl(
        'https://datav.aliyuncs.com/share/989094848b2a0a3f75a96d2545930a88',
        this.$route.name === 'GlobalDataScreen'
          ? this.$route.query
          : { companyId: this.companyId }
      )
    }
  },

  created() {
    this.resizeListener()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resize, true)
  },

  methods: {
    resizeListener() {
      const that = this
      window.addEventListener('resize', function() {
        if (!isFullScreen()) {
          if (!isFullScreen()) {
            that.isFullScreen = false
          }
        }
      })
    },
    toFullOrExit() {
      fullToggle('dataScreen', this, exitFullScreen, fullScreen)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-box {
  position: relative;
  .btn {
    position: absolute;
    cursor: pointer;
    top: 30px;
    left: 30px;
    color: #fff;
    font-size: 32px;
  }
}
.is-full {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999999;
  padding: 0;
}
</style>
